import {localized} from 'i18n/i18n';
import {FC, memo, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';
import {selectUserById} from 'state/features/api/user-slice';
import {primaryColor} from 'styles/color-constants';
import {BasicCard} from 'view/components/default-components/basic-card/basic-card';
import {TextLabel} from 'view/components/default-components/text-label';
import {RemoveMachineRow} from './remove-machine-row';
export const RemoveMachineCard: FC = memo(() => {
  let {userId} = useParams<{userId: string}>();
  const user = useSelector(selectUserById(Number(userId)));

  const machineRows = useMemo(
    () =>
      user?.machineIds?.map((machineId) => <RemoveMachineRow key={machineId} userId={user.id} machineId={machineId} />),
    [user?.id, user?.machineIds],
  );

  return (
    <BasicCard sx={{width: 'unset', height: 'fit-contet'}}>
      <TextLabel variant="h6" fontWeight="bold" color={primaryColor} marginBottom={0}>
        {localized('Machines')}
      </TextLabel>
      <TextLabel variant="body1" marginBottom={3}>
        {localized('RemoveMachineMeta')}
      </TextLabel>
      <TextLabel variant="h6" fontWeight="bold" marginBottom={0}>
        {localized('SerialNumber')}
      </TextLabel>
      {machineRows}
    </BasicCard>
  );
});
